import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { useUIStore, useAgentStore } from '@/stores';
import { NAV_ITEMS } from '@/routes/routes';
import { HomeIcon, ServerIcon, SettingsIcon, ChevronLeftIcon } from '@/components/icons';
import styles from './Sidebar.module.css';

const ICONS: Record<string, React.ReactNode> = {
  home: <HomeIcon />,
  server: <ServerIcon />,
  settings: <SettingsIcon />,
};

interface SidebarProps {
  collapsed?: boolean;
}

export function Sidebar({ collapsed = false }: SidebarProps) {
  const { sidebarCollapsed, setSidebarCollapsed } = useUIStore();
  const onlineCount = useAgentStore((state) => state.getOnlineCount());
  
  const isCollapsed = collapsed || sidebarCollapsed;
  
  return (
    <aside className={clsx(styles.sidebar, isCollapsed && styles.collapsed)}>
      <nav className={styles.nav}>
        <ul className={styles.navList}>
          {NAV_ITEMS.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  clsx(styles.navLink, isActive && styles.active)
                }
                title={isCollapsed ? item.label : undefined}
              >
                <span className={styles.navIcon}>{ICONS[item.icon]}</span>
                {!isCollapsed && (
                  <>
                    <span className={styles.navLabel}>{item.label}</span>
                    {item.icon === 'server' && onlineCount > 0 && (
                      <span className={styles.badge}>{onlineCount}</span>
                    )}
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      
      <button
        type="button"
        className={styles.collapseButton}
        onClick={() => setSidebarCollapsed(!isCollapsed)}
        aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        aria-expanded={!isCollapsed}
        aria-controls="sidebar-nav"
      >
        <ChevronLeftIcon 
          className={clsx(styles.collapseIcon, isCollapsed && styles.rotated)}
        />
      </button>
    </aside>
  );
}
